module.exports = __webpack_public_path__ + "static/media/icon_tips.ed9f2618.svg";